import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Typography, Popover } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";
import CarrierNetworkManuallyAddStatus from "../../CarrierNetworkManuallyAddStatus/CarrierNetworkManuallyAddStatus";
import CarrierNetworkActionBase from "../CarrierNetworkActionBase/CarrierNetworkActionBase";
import { CarrierService } from "../../../../../../services/CarrierService";
import { AlertContext } from "../../../../../Dashboard/Dashboard";

export default function CarrierNetworkOpenAction({ 
  networkUserId,
  activeUser,
  networkStatus,
  getNetworkStatus,
  carrier,
  getCarrier,
  setIsLoading,
  setIsUpdating,
  canAddAsLead,
  canAddManually,
  userDefault
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const pid = open ? "carrier-network-actions-popover" : undefined;

  const handleAddAsLead = () => {
    setIsLoading(true);
    setIsUpdating(true);
    const payload = {
      userId: activeUser.userIdMcld,
      carrierId: carrier.id
    };

    CarrierService.AddCarrierLead(instance, payload).then(() => {
      getNetworkStatus();
      getCarrier();
      setIsUpdating(false);
    }).catch(error => {
      console.error(error);
      getNetworkStatus();
      setIsUpdating(false);
      warning(error);
    });
  };

  const handleClick = (e) => {
    if (canAddManually) {
      setAnchorEl(e.currentTarget);
    } else if (canAddAsLead) {
      handleAddAsLead();
    }
  };

  return (
    <>
      <CarrierNetworkActionBase
        backgroundColor="primary.60"
        canAddAsLead={canAddAsLead}
        canAddManually={canAddManually}
        onClick={(e) => handleClick(e)}
        isOpen
      >
        <AddIcon sx={{ fontSize: "20px" }} />
        <Typography variant="h4" sx={{ padding: "0 4px" }}>
          Add as Lead
        </Typography>
        {(canAddManually) &&
          <KeyboardArrowDownIcon sx={{ fontSize: "20px" }} />
        }
      </CarrierNetworkActionBase>
      <Popover
        id={pid}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: { boxShadow: "elevation3" },
          }
        }}
      >
        {canAddManually &&
           <CarrierNetworkManuallyAddStatus
             networkUserId={networkUserId}
             cancel={setAnchorEl}
             networkStatus={networkStatus}
             getNetworkStatus={getNetworkStatus}
             carrier={carrier}
             networkUser={userDefault}
             getCarrier={getCarrier}
           />
        }
      </Popover>
    </>
  );
}

CarrierNetworkOpenAction.propTypes = {
  networkStatus: PropTypes.string.isRequired,
  setIsLoading: PropTypes.func,
  getNetworkStatus: PropTypes.func.isRequired,
  carrier: PropTypes.object.isRequired,
  activeUser: PropTypes.object,
  networkUserId: PropTypes.string,
  getCarrier: PropTypes.func.isRequired,
  setIsUpdating: PropTypes.func.isRequired,
  canAddAsLead: PropTypes.bool.isRequired,
  canAddManually: PropTypes.bool.isRequired,
  userDefault: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};